import type { CSSProperties } from "react";
import styles from "./orb.module.css";

/** Names of the six avatar orbs (tokens `color.avatarOrbs`, the onboarding glow picker). */
export const ORB_NAMES = ["teal", "azure", "ember", "violet", "magenta", "moss"] as const;

/** The boards' avatar orb: `radial-gradient(66% 60% at 34% 26%, light, dark)` on the token pair. */
export function Orb({ index, size = 20, label }: { index: number; size?: number; label?: string }) {
  const i = ((index % 6) + 6) % 6;
  const style = {
    "--orb-light": `var(--color-avatar-orbs-${i}-0)`,
    "--orb-dark": `var(--color-avatar-orbs-${i}-1)`,
    "--orb-size": `${size}px`,
  } as CSSProperties;
  return (
    <span
      className={styles.orb}
      style={style}
      data-orb={i}
      {...(label ? { role: "img", "aria-label": label, title: label } : { "aria-hidden": true })}
    />
  );
}
